import mixpanel from 'mixpanel-browser'
import { init, replayIntegration, browserTracingIntegration } from '@sentry/remix'
import { RemixBrowser, useLocation, useMatches } from '@remix-run/react'
import i18next from 'i18next'
import I18nextBrowserLanguageDetector from 'i18next-browser-languagedetector'
import { startTransition, useEffect } from 'react'
import { hydrateRoot } from 'react-dom/client'
import { I18nextProvider, initReactI18next } from 'react-i18next'
import { getInitialNamespaces } from 'remix-i18next/client'
import * as i18n from '#app/modules/i18n/i18n'

mixpanel.init('e2fe2bf9c99c3caeb860619d48575d0f', {
  autocapture: true,
  record_sessions_percent: 0,
})

init({
  dsn: 'https://34021a85692b630146671639e8db0650@o4507692419710976.ingest.us.sentry.io/4511170999812096',
  tracesSampleRate: 1,
  enableLogs: true,

  integrations: [
    browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches,
    }),
    replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  ],

  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 1,
  sendDefaultPii: false,
})

async function main() {
  // eslint-disable-next-line import/no-named-as-default-member
  await i18next
    // Initialize `react-i18next`.
    .use(initReactI18next)
    // Setup client-side language detector.
    .use(I18nextBrowserLanguageDetector)
    .init({
      ...i18n,
      ns: getInitialNamespaces(),
      detection: {
        // Enable HTML tag detection only by detecting the language server-side.
        // Using `<html lang>` attribute to communicate the detected language to the client.
        order: ['htmlTag'],
        // Since we solely utilize htmlTag, browser language caching is unnecessary.
        caches: [],
      },
    })

  startTransition(() => {
    hydrateRoot(
      document,
      <I18nextProvider i18n={i18next}>
        <RemixBrowser />
      </I18nextProvider>,
    )
  })
}

main().catch((error) => console.error(error))
